import EditorNavigation from './EditorNavigation';

export default EditorNavigation;
